import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import SvgIcon from '@/components/SvgIcon/SvgIcon.vue';

@Component({
  components: { SvgIcon },
})
export default class DeckTab extends Vue {
  @Prop({ type: String, default: '' })
  readonly tab!: string;

  @Prop({ type: String, default: '' })
  readonly currentTab!: string;

  @Prop({ type: String, default: '' })
  readonly name!: string;

  setTab(tab: string) {
    this.$emit('setTab', tab);
  }
}
